module.exports = __webpack_public_path__ + "img/insurance.94ee1ad.webp";